var _toConsumableArray = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

var _classCallCheck = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var base64url = require('../help/base64url');

var isDisjoint = require('../help/is_disjoint');

var isObject = require('../help/is_object');

var deepClone = require('../help/deep_clone');

var _require = require('../errors'),
    JWSInvalid = _require.JWSInvalid;

var _require2 = require('../jwa'),
    sign = _require2.sign;

var getKey = require('../help/get_key');

var serializers = require('./serializers');

var PROCESS_RECIPIENT = Symbol('PROCESS_RECIPIENT');

var Sign =
/*#__PURE__*/
function () {
  "use strict";

  function Sign(payload) {
    _classCallCheck(this, Sign);

    if (typeof payload === 'string') {
      payload = base64url.encode(payload);
    } else if (Buffer.isBuffer(payload)) {
      payload = base64url.encodeBuffer(payload);
      this._binary = true;
    } else if (isObject(payload)) {
      payload = base64url.JSON.encode(payload);
    } else {
      throw new TypeError('payload argument must be a Buffer, string or an object');
    }

    this._payload = payload;
    this._recipients = [];
  }
  /*
   * @public
   */


  _createClass(Sign, [{
    key: "recipient",
    value: function recipient(key, protectedHeader, unprotectedHeader) {
      key = getKey(key);

      if (protectedHeader !== undefined && !isObject(protectedHeader)) {
        throw new TypeError('protectedHeader argument must be a plain object when provided');
      }

      if (unprotectedHeader !== undefined && !isObject(unprotectedHeader)) {
        throw new TypeError('unprotectedHeader argument must be a plain object when provided');
      }

      if (!isDisjoint(protectedHeader, unprotectedHeader)) {
        throw new JWSInvalid('JWS Protected and JWS Unprotected Header Parameter names must be disjoint');
      }

      this._recipients.push({
        key: key,
        protectedHeader: protectedHeader ? deepClone(protectedHeader) : undefined,
        unprotectedHeader: unprotectedHeader ? deepClone(unprotectedHeader) : undefined
      });

      return this;
    }
    /*
     * @private
     */

  }, {
    key: PROCESS_RECIPIENT,
    value: function value(recipient, first) {
      var key = recipient.key,
          protectedHeader = recipient.protectedHeader,
          unprotectedHeader = recipient.unprotectedHeader;

      if (key.use === 'enc') {
        throw new TypeError('a key with "use":"enc" is not usable for signing');
      }

      var joseHeader = {
        protected: protectedHeader || {},
        unprotected: unprotectedHeader || {}
      };
      var alg = joseHeader.protected.alg || joseHeader.unprotected.alg;

      if (!alg) {
        alg = key.alg || _toConsumableArray(key.algorithms('sign'))[0];

        if (recipient.protectedHeader) {
          joseHeader.protected.alg = recipient.protectedHeader.alg = alg;
        } else {
          joseHeader.protected = recipient.protectedHeader = {
            alg: alg
          };
        }
      }

      if (!alg) {
        throw new JWSInvalid('could not resolve a usable "alg" for a recipient');
      }

      recipient.header = unprotectedHeader;
      recipient.protected = Object.keys(joseHeader.protected).length ? base64url.JSON.encode(joseHeader.protected) : '';

      if (first && joseHeader.protected.crit && joseHeader.protected.crit.includes('b64') && joseHeader.protected.b64 === false) {
        if (this._binary) {
          this._payload = base64url.decodeToBuffer(this._payload);
        } else {
          this._payload = base64url.decode(this._payload);
        }
      }

      var data = Buffer.concat([Buffer.from(recipient.protected || ''), Buffer.from('.'), Buffer.from(this._payload)]);
      recipient.signature = base64url.encodeBuffer(sign(alg, key, data));
    }
    /*
     * @public
     */

  }, {
    key: "sign",
    value: function sign(serialization) {
      var _this = this;

      var serializer = serializers[serialization];

      if (!serializer) {
        throw new TypeError('serialization must be one of "compact", "flattened", "general"');
      }

      if (!this._recipients.length) {
        throw new JWSInvalid('missing recipients');
      }

      serializer.validate(this, this._recipients);

      this._recipients.forEach(function (recipient, i) {
        _this[PROCESS_RECIPIENT](recipient, i === 0);
      });

      return serializer(this._payload, this._recipients);
    }
  }]);

  return Sign;
}();

module.exports = Sign;